import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { IServiceAvailability } from 'src/app/models';
import { TicketingType } from 'src/app/models/enums';
import { IBookingDetails } from 'src/app/models/booking/bookingDetails';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-change-booking-availability',
  templateUrl: './modal-change-booking-availability.component.html',
  styleUrl: './modal-change-booking-availability.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalChangeBookingAvailabilityComponent implements OnChanges {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() routes: any;
  @Input() availabilities: any;
  @Input() booking?: IBookingDetails;
  @Input() multiple?: boolean = false;
  @Input() text?: string = '';
  @Input() loading?: boolean = false;
  @Input() loadingPercentage?: number = 0;
  @Input() loadingDetail: string = '';
  @Input() loadingAvailabilities?: boolean = false;
  @Input() needsConfirmation?: boolean = false;
  @Input() hasTicketing?: boolean = false;
  @Output() action = new EventEmitter<any>();
  @Output() update = new EventEmitter<any>();

  public availabilitySelected: IServiceAvailability | undefined;
  public confirmChange: boolean = false;
  public notify: boolean = true;
  public recomputePrice: boolean = false;

  public images = images;
  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json',
  };

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  get showRecomputePriceToggle(): boolean {
    if (this.multiple) return !!this.hasTicketing;
    if (!this.booking) return false;
    return (
      !!this.booking.ticketingType &&
      this.booking.ticketingType !== TicketingType.None
    );
  }

  ngOnChanges(): void {
    this.confirmChange = false;
    if (this.routes) this.routes.edit.disabled = false;
    if (this.availabilities) {
      this.availabilities.edit.disabled = false;
      this.availabilitySelected = this.availabilities.value
        ? { id: this.availabilities.value }
        : undefined;
    } else {
      this.availabilitySelected = undefined;
    }
  }

  async set(event: any) {
    this.availabilitySelected = { id: event };
  }

  setRoute(event: any) {
    this.update.emit({ id: event });
    this.availabilitySelected = undefined;
  }

  onCancel() {
    if (this.confirmChange) {
      this.routes.edit.disabled = false;
      this.availabilities.edit.disabled = false;
      this.confirmChange = false;
    } else this.modal.hide();
  }

  onSubmit() {
    if (this.needsConfirmation && !this.confirmChange) {
      this.routes.edit.disabled = true;
      this.availabilities.edit.disabled = true;
      this.confirmChange = true;
    } else {
      if (this.multiple) {
        this.action.emit({
          newAvailability: this.availabilitySelected,
          sendNotification: this.notify,
          recomputePrice: this.recomputePrice,
        });
      } else {
        this.booking!.availability = this.availabilitySelected!;
        this.action.emit({
          booking: this.booking,
          sendNotification: this.notify,
          recomputePrice: this.recomputePrice,
        });
        this.modal.toggle();
      }
    }
  }
}
